var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRejectedicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2473",
    "data-name": "Group 2473",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3463",
    "data-name": "Path 3463",
    d: "M-500.981,119.65a12.5,12.5,0,0,1,12.514-12.484,12.518,12.518,0,0,1,12.486,12.542,12.507,12.507,0,0,1-12.541,12.458A12.507,12.507,0,0,1-500.981,119.65Zm12.5-9.36a9.383,9.383,0,0,0-9.377,9.362,9.385,9.385,0,0,0,9.374,9.391,9.4,9.4,0,0,0,9.379-9.364A9.382,9.382,0,0,0-488.48,110.29Z",
    transform: "translate(500.981 -107.166)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3464",
    "data-name": "Path 3464",
    d: "M-334.166,271.869c.689.688,1.341,1.334,1.987,1.987a1.522,1.522,0,0,1,.422,1.629,1.555,1.555,0,0,1-2.6.609c-.614-.594-1.21-1.207-1.815-1.81-.056-.056-.116-.109-.186-.174-.073.068-.138.127-.2.188-.6.6-1.192,1.2-1.8,1.793a1.511,1.511,0,0,1-1.59.409,1.489,1.489,0,0,1-1.078-1.235,1.54,1.54,0,0,1,.488-1.414q.881-.88,1.761-1.761c.062-.062.121-.127.216-.227-.22-.209-.435-.4-.641-.609-.463-.458-.927-.915-1.38-1.382a1.539,1.539,0,0,1-.322-1.755,1.566,1.566,0,0,1,1.487-.915,1.62,1.62,0,0,1,1.1.513c.641.647,1.287,1.29,1.95,1.953.071-.066.135-.123.2-.184.6-.6,1.2-1.216,1.815-1.81a1.556,1.556,0,0,1,2.6.608,1.527,1.527,0,0,1-.424,1.63c-.584.59-1.173,1.175-1.76,1.761C-334,271.735-334.071,271.789-334.166,271.869Z",
    transform: "translate(348.86 -259.385)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectedicon);
export default __webpack_public_path__ + "static/media/rejectedicon.cd1cde22ab849ac63ff30fef79a97ed5.svg";
export { ForwardRef as ReactComponent };